import React from 'react'
import { webSocket } from './socket'

export var userResponse, locationResponse;


export const sendLoadUserData = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'loadUserData': {} }));
        userResponse = resolve;
    });
    return promise;
}

export const loadUserData = () => {
    const promise = new Promise(function(resolve, reject) {
        sendLoadUserData().then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendRequestUsers = function () {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'UserRequest': {} }));
        userResponse = resolve;
    });
    return promise;
}

export const requestUsers = function () {
    const promise = new Promise(function(resolve, reject) {
        sendRequestUsers().then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendRequestLocations = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'LocationRequest': data }));
        locationResponse = resolve;
    });
    return promise;
}

export const requestLocations = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendRequestLocations(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendCreateCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'createCustomer': data }));
        userResponse = resolve;
    });
    return promise;
}

export const createCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendCreateCustomer(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendDeleteUser = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'deleteTechUser': data }));
        userResponse = resolve;
    });
    return promise;
}

export const deleteUser = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendDeleteUser(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendDeleteCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'deleteCustomer': data }));
        userResponse = resolve;
    });
    return promise;
}

export const deleteCustomer = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendDeleteCustomer(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}



export const sendUpdateUser = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'updateUserInfo': data }));
        userResponse = resolve;
    });
    return promise;
}

export const updateUser = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendUpdateUser(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendVerifyToken = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'verifyToken': data }));
        userResponse = resolve;
    });
    return promise;
}

export const verifyToken = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendVerifyToken(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}



export const sendVerifyCode = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'verifyCode': data }));
        userResponse = resolve;
    });
    return promise;
}

export const verifyCode = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendVerifyCode(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendResetPassword = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'verifyToken': data }));
        userResponse = resolve;
    });
    return promise;
}

export const resetPassword = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendResetPassword(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendUpdatePasswordExpiration = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'updatePasswordExpiration': data }));
        userResponse = resolve;
    });
    return promise;
}

export const updatePassword = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendUpdatePasswordExpiration(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendEnableUser = function (data) {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'enableUser': data }));
        userResponse = resolve;
    });
    return promise;
}

export const enableUser = function (data) {
    const promise = new Promise(function(resolve, reject) {
        sendEnableUser(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}